/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay.js.map